const LeftOptions = ({ options, onSelectOption, activeOption }) => {
  return (
    <div className="card">
      <div className="card-body">
        <div className="left-options">
          {options?.map((option) => {
            return (
              <li
                key={option}
                className={`option ${option === activeOption ? 'active' : ''}`}
                onClick={() => onSelectOption(option)}
              >
                <div className="option-name">
                  <div className={`${option === activeOption ? 'active' : ''}`}></div>
                  {option}
                </div>
              </li>
            );
          })}
        </div>
      </div>
    </div>
  );
};
export default LeftOptions;
